<template>
      
    <nav v-if='transparent' class="navbar resize navbar-expand-sm  color-white navigate col align-items-center" :style="{background:'transparent'}">
      <!-- 确保无论是宽屏还是窄屏，navbar-brand都显示 -->
      <!-- <a href="##" class="navbar-brand">导航栏</a> -->
      <img class="logo navbar-brand" src="../assets/images/zksino_logo.png" :style="{left:clientWidth/2-50+'px'}">
      <div class="container-fluid row">
        　<!-- .navbar-toggle样式用于toggle收缩的内容，即nav-collapse collapse样式所在元素 -->   
        <button class="navbar-toggler icon-50" type="button" data-toggle="collapse" data-target="#navigate-menu">
          <img class="menu-img" src="../assets/images/navigate_menu.png">
        </button>
        <!-- 屏幕宽度小于768px时，div.navbar-responsive-collapse容器里的内容都会隐藏，显示icon-bar图标，当点击icon-bar图标时，再展开。屏幕大于768px时，默认显示。 -->
        <div class="collapse navbar-collapse" id="navigate-menu" :style="{backgorund:'#ECECEC'}">
          <div class="col-md-3 text-center height-50 navigate-menu-item">解决方案</div>
          <div class="col-md-3 text-center height-50 navigate-menu-item">平台</div>
          <div class="col-md-3 text-center height-50 navigate-menu-item">服务</div>
          <div class="col-md-3 text-center height-50 navigate-menu-item">我们的案例</div>
        </div>
      </div>
    </nav>
    <nav v-else class="navbar navbar-expand-sm  color-black navigate col align-items-center" :style="{background:'#ECECEC'}">
      <!-- 确保无论是宽屏还是窄屏，navbar-brand都显示 -->
      <!-- <a href="##" class="navbar-brand">导航栏</a> -->
      <img class="logo" src="../assets/images/zksino_logo.png" :style="{left:clientWidth/2-50+'px'}">
      <div class="container-fluid row">
        　<!-- .navbar-toggle样式用于toggle收缩的内容，即nav-collapse collapse样式所在元素 -->   
        <button class="navbar-toggler icon-50" type="button" data-toggle="collapse" data-target="#navigate-menu">
          <img class="menu-img" src="../assets/images/navigate_menu.png">
        </button>
        <!-- 屏幕宽度小于768px时，div.navbar-responsive-collapse容器里的内容都会隐藏，显示icon-bar图标，当点击icon-bar图标时，再展开。屏幕大于768px时，默认显示。 -->
        <div class="collapse navbar-collapse" id="navigate-menu" :style="{backgorund:'#ECECEC'}">
          <div class="col-md-3 text-center height-50 navigate-menu-item">解决方案</div>
          <div class="col-md-3 text-center height-50 navigate-menu-item">平台</div>
          <div class="col-md-3 text-center height-50 navigate-menu-item">服务</div>
          <div class="col-md-3 text-center height-50 navigate-menu-item">我们的案例</div>
        </div>
      </div>
    </nav>
    
  
</template>
  
  <script>
  export default {
    name: 'navigate',
    data () {
      return {
        show:true,
        clientWidth:null,
        clientHeight:null,
        transparent:true,
      }
    },
    methods:{
      handleScroll(){
        let top=document.documentElement.scrollTop
        if(top==0){
          this.transparent=true
        }else{
          this.transparent=false
        }
      },
    },
    mounted:function(){
      const that = this
      let wW = document.documentElement.clientWidth;// 窗口宽度
      let hH = document.documentElement.clientHeight;// 窗口高度
      console.log('宽度:',wW)
      console.log('高度:',hH)
      that.clientHeight=hH
      that.clientWidth=wW
      let top=document.documentElement.scrollTop
      if(top==0){
        that.transparent=true
      }else{
        that.transparent=false
      }
      window.addEventListener('scroll',this.handleScroll,true)
      if(wW<768){
        that.show=false
      }else{
        that.show=true
      }
    },
    created:function(){
      
    },
    destroyed:function(){}
  }
  </script>
  
  <style scoped>
@import url("../../static/css/global.css");
  .navigate{
    position: fixed;
    top:0;
    z-index: 1000;
    width:100%;

  }
  .logo{
    width:100px;
    height:50px;
    top:0;
    position: fixed;
    z-index:2000;
  }
  .menu-img{
    width:30px;
    height:30px;
    border:1px solid white;
    border-radius: 3px;
  }
  .navigate-menu-item{
    height:50px;
    line-height: 50px;
  }
  </style>


// WEBPACK FOOTER //
// src/components/navigate.vue